import React, { createContext, useContext, useEffect, useState } from 'react';

const STRINGS = {
  fr: {
    // Nav
    'nav.home': 'Accueil',
    'nav.features': 'Fonctionnalités',
    'nav.pricing': 'Tarifs',
    'nav.dashboard': 'Tableau de bord',
    'nav.upload': 'Importer',
    'nav.publishing': 'Publier',
    'nav.admin': 'Admin',
    'nav.login': 'Connexion',
    'nav.signup': 'Commencer',
    'nav.logout': 'Se déconnecter',

    // Footer
    'footer.tagline': 'Transforme n\'importe quelle vidéo longue en clips courts viraux. Détecte automatiquement les meilleurs moments.',
    'footer.product': 'Produit',
    'footer.compare': 'Comparer',
    'footer.support': 'Support',
    'footer.support.help': 'Une question ou un souci ? Écris-nous.',
    'footer.copy': '© 2026 HighlightAI · Conçu pour les créateurs',

    // Landing
    'landing.badge': 'Moteur IA de Highlights · v2',
    'landing.title.line1': 'Une longue vidéo.',
    'landing.title.line2': 'Des dizaines de clips viraux.',
    'landing.title.line3': 'Zéro montage.',
    'landing.subtitle': 'Dépose un podcast, un stream, une interview ou n\'importe quel contenu long. HighlightAI repère les pics d\'émotion, les moments drôles, les hooks viraux — puis livre des TikToks, Shorts et Reels prêts à publier avec sous-titres dynamiques.',
    'landing.cta.primary': 'Générer mes premiers clips',
    'landing.cta.secondary': 'Voir les tarifs',
    'landing.social': 'Adopté par plus de 12 400 créateurs · Aucune carte requise',

    'landing.features.tag': '// Ce que ça fait',
    'landing.features.title.line1': 'Assez malin pour repérer',
    'landing.features.title.line2': 'les moments que l\'humain rate.',
    'landing.features.desc': 'Entraîné sur des millions de clips viraux, notre moteur analyse l\'énergie audio, les pics émotionnels, les réactions du public et le rythme pour extraire uniquement ce qui mérite d\'être publié.',
    'feature1.title': 'Détection IA',
    'feature1.desc': 'Moments drôles, pics émotionnels, pics d\'énergie, scènes d\'action et hooks viraux détectés automatiquement.',
    'feature2.title': 'Auto-clip 9:16 · 1:1 · 16:9',
    'feature2.desc': 'TikTok, Shorts, Reels et format horizontal YouTube — tout est généré en une seule passe.',
    'feature3.title': 'Sous-titres style TikTok',
    'feature3.desc': 'Sous-titres animés, mots-clés mis en couleur, synchronisation parfaite avec l\'audio.',
    'feature4.title': 'Score Viral',
    'feature4.desc': 'Chaque clip reçoit un score d\'engagement, de viralité et de rétention pour savoir lequel poster en premier.',
    'feature5.title': 'Recadrage intelligent',
    'feature5.desc': 'Auto-zoom sur les visages, recadrage dynamique et effets emojis sans montage manuel.',
    'feature6.title': 'Multilingue',
    'feature6.desc': 'Transcription Whisper supportant plus de 50 langues avec une précision au timestamp.',
    'feature7.title': 'Import depuis URL',
    'feature7.desc': 'Colle un lien YouTube, Twitch, Vimeo ou Dailymotion — l\'IA télécharge et clippe la vidéo automatiquement. Plus besoin de download manuel.',

    'landing.how.tag': '// Workflow',
    'landing.how.title.line1': 'Trois étapes.',
    'landing.how.title.line2': 'Un mur de clips prêts à publier.',
    'step1.title': 'Dépose ta vidéo',
    'step1.desc': 'Drag & drop MP4, MOV ou AVI — jusqu\'à 5Go. Ou colle un lien de stream.',
    'step2.title': 'L\'IA fait le show',
    'step2.desc': 'Whisper transcrit. GPT note. Les highlights sont coupés, sous-titrés et classés.',
    'step3.title': 'Poste & deviens viral',
    'step3.desc': 'Télécharge en HD ou partage direct sur TikTok, YouTube Shorts et Instagram Reels.',

    'landing.cta2.title.line1': 'Arrête de scruter ta timeline.',
    'landing.cta2.title.line2': 'Laisse l\'IA te servir l\'or sur un plateau.',
    'landing.cta2.desc': 'Gratuit à vie pour les 30 premières minutes d\'upload chaque mois.',
    'landing.cta2.start': 'Commencer gratuitement',
    'landing.cta2.pricing': 'Tarifs',

    // Pricing
    'pricing.tag': '// Tarifs',
    'pricing.title.line1': 'Commence gratuitement.',
    'pricing.title.line2': 'Passe à l\'échelle quand tu deviens viral.',
    'pricing.subtitle': 'Aucune carte requise. Annule à tout moment.',
    'pricing.free.name': 'Gratuit',
    'pricing.free.sub': 'Teste la magie',
    'pricing.pro.name': 'Créateur',
    'pricing.pro.sub': 'Pour les créateurs ambitieux',
    'pricing.studio.name': 'Studio',
    'pricing.studio.sub': 'Agences et équipes',
    'pricing.popular': 'Le plus populaire',
    'pricing.founder': 'Prix fondateur',
    'pricing.founder.sub': 'Tarif réservé aux premiers utilisateurs',
    'pricing.reassurance': 'Les tarifs actuels sont réservés aux premiers utilisateurs et évolueront après le lancement officiel.',
    'pricing.month': '/ mois',
    'pricing.start.free': 'Commencer gratuitement',
    'pricing.go': 'Passer à',
    'pricing.custom': 'Besoin d\'un plan sur mesure pour un média ou une entreprise ?',
    'pricing.contact': 'Contacte-nous',
    // Free features
    'pf.minutes': '30 minutes d\'upload / mois',
    'pf.720p': 'Export jusqu\'à 720p',
    'pf.captions1': 'Sous-titres auto (1 langue)',
    'pf.watermark': 'Filigrane HighlightAI',
    'pf.hd1080': 'Export HD (1080p)',
    'pf.queue': 'File prioritaire',
    // Pro features
    'pf.unlimited': 'Uploads illimités',
    'pf.hd1080.y': 'Export HD 1080p',
    'pf.nowatermark': 'Sans filigrane',
    'pf.urlimport': 'Import direct depuis URL (YouTube, Twitch, Vimeo…)',
    'pf.multi': 'Sous-titres multilingues (50+)',
    'pf.priority': 'Traitement en file prioritaire',
    'pf.direct': 'Publication directe TikTok / YT / IG',
    // Studio features
    'pf.everything': 'Tout du plan Créateur',
    'pf.4k': 'Export 4K',
    'pf.team': 'Espace équipe (5 sièges)',
    'pf.brand': 'Kit de marque personnalisé',
    'pf.api': 'Accès API',
    'pf.support': 'Support dédié',

    // Auth
    'auth.welcome': 'Bienvenue à nouveau',
    'auth.welcome.sub': 'Connecte-toi pour continuer à générer des clips viraux.',
    'auth.create': 'Crée ton compte',
    'auth.create.sub': '30 minutes gratuites chaque mois. Aucune carte requise.',
    'auth.continue.google': 'Continuer avec Google',
    'auth.or': 'OU',
    'auth.name': 'Nom',
    'auth.email': 'Email',
    'auth.password': 'Mot de passe',
    'auth.signin': 'Se connecter',
    'auth.signing': 'Connexion...',
    'auth.creating': 'Création...',
    'auth.signup': 'Créer mon compte',
    'auth.noaccount': 'Pas de compte ?',
    'auth.signup.link': 'Inscris-toi gratuitement',
    'auth.haveaccount': 'Déjà membre ?',
    'auth.signin.link': 'Se connecter',
    'auth.welcomed': 'Bienvenue',
    'auth.invalid': 'Identifiants invalides',
    'auth.created': 'Compte créé — passons à l\'onboarding.',
    'auth.regfail': 'Échec de l\'inscription',
    'auth.gfail': 'Connexion Google échouée',
    'auth.gconnect': 'Connexion à Google...',
    'auth.gsuccess': 'Connecté avec Google',
    'auth.nosession': 'Aucune session — redirection...',
    'auth.failed': 'Échec. Redirection vers la connexion...',

    // Onboarding
    'onb.step': 'Étape',
    'onb.welcome.title': 'Bienvenue sur HighlightAI',
    'onb.welcome.sub': "Configurons ton espace en moins d'une minute.",
    'onb.welcome.cta': 'Commencer',
    'onb.type.title': 'Quel type de contenu crées-tu principalement ?',
    'onb.type.sub': 'Ta réponse nous aidera à personnaliser tes recommandations à venir.',
    'onb.platforms.title': 'Où publies-tu principalement ?',
    'onb.platforms.sub': 'Sélectionne toutes les plateformes qui comptent pour toi.',
    'onb.goal.title': 'Quel est ton objectif principal ?',
    'onb.goal.sub': 'On adaptera bientôt l\'AI Coach et les insights à ton objectif.',
    'onb.cadence.title': 'Combien de vidéos publies-tu chaque semaine ?',
    'onb.cadence.sub': 'Pour caler le rythme de suggestions au bon tempo.',
    'onb.done.title': 'Ton espace est prêt.',
    'onb.done.sub': 'On personnalisera progressivement HighlightAI selon tes réponses.',
    'onb.title1': 'Que crées-tu ?',
    'onb.sub1': 'Pour calibrer la détection des highlights.',
    'onb.title2': 'Où vas-tu publier ?',
    'onb.sub2': 'On optimise les formats en conséquence.',
    'onb.title3': 'Tout est prêt.',
    'onb.sub3': 'Dépose ta première vidéo et regarde la magie opérer.',
    'onb.podcast': 'Podcasts',
    'onb.gaming': 'Gaming',
    'onb.business': 'Business',
    'onb.finance': 'Finance',
    'onb.education': 'Éducation',
    'onb.fitness': 'Fitness',
    'onb.lifestyle': 'Lifestyle',
    'onb.interview': 'Interviews',
    'onb.vlog': 'Vlogs',
    'onb.sport': 'Sport',
    'onb.other': 'Autre',
    'onb.goal.views': 'Obtenir plus de vues',
    'onb.goal.subs': 'Gagner des abonnés',
    'onb.goal.clients': 'Trouver des clients',
    'onb.goal.time': 'Gagner du temps',
    'onb.goal.brand': 'Développer ma marque',
    'onb.cadence.1-3': '1 à 3',
    'onb.cadence.4-7': '4 à 7',
    'onb.cadence.8-15': '8 à 15',
    'onb.cadence.15+': '15 et plus',
    'onb.skip': "Passer pour l'instant",
    'onb.back': 'Retour',
    'onb.next': 'Continuer',
    'onb.start': 'Ouvrir mon espace →',
    'onb.ready': 'Ton moteur de highlights est calibré. À toi de jouer.',

    // Dashboard
    'dash.tag': '// Salle de contrôle',
    'dash.greeting': 'Salut {name}, prêt pour la prochaine vague ?',
    'dash.upload': 'Nouvel upload',
    'dash.stat.videos': 'Vidéos',
    'dash.stat.clips': 'Clips générés',
    'dash.stat.time': 'Temps de traitement',
    'dash.stat.viral': 'Score viral moyen',
    'dash.library': 'Ta bibliothèque',
    'dash.videos.count': '{n} vidéos',
    'dash.empty.title': 'Ta bibliothèque est vide',
    'dash.empty.desc': 'Upload ta première vidéo longue et regarde HighlightAI la transformer en mur de clips.',
    'dash.empty.cta': 'Uploader une première vidéo',
    'dash.cats': 'Top catégories',
    'dash.cats.empty': 'Pas encore de données. Upload une vidéo pour remplir.',
    'dash.upgrade.title': 'Passer à Créateur',
    'dash.upgrade.desc': 'Uploads illimités, exports HD, sans filigrane.',
    'dash.upgrade.cta': 'Voir les plans',
    'dash.ready': 'Prêt',
    'dash.row.subtitle': '{type} · {n} clips · traité en {t}s',
    'dash.loading': 'Chargement...',

    // Upload
    'up.tag': '// Importer',
    'up.title': 'Dépose ta vidéo longue.',
    'up.subtitle': 'Jusqu\'à 5Go · MP4 / MOV / AVI · podcasts, interviews, streams, gaming, tout est ok.',
    'up.drop.active': 'Lâche-la là !',
    'up.drop.idle': 'Glisse & dépose ta vidéo ici',
    'up.drop.hint': 'ou clique pour parcourir · MP4 / MOV / AVI · 5Go max',
    'up.label.title': 'Titre',
    'up.label.title.ph': 'Épisode 42 - Le Futur de l\'IA',
    'up.label.type': 'Type de contenu',
    'up.cta': 'Générer les clips',
    'up.toobig': 'Fichier trop volumineux (5Go max)',
    'up.rejected': 'Fichier rejeté',
    'up.first': 'Dépose d\'abord une vidéo',
    'up.proc.title': 'L\'IA s\'active...',
    'up.proc.upload.title': 'Upload en cours...',
    'up.success': '{n} clips générés !',
    'up.fail': 'Upload échoué',
    'up.stage1': 'Upload de la vidéo...',
    'up.stage2': 'Extraction audio...',
    'up.stage3': 'Transcription avec Whisper...',
    'up.stage4': 'Analyse des pics émotionnels...',
    'up.stage5': 'Notation des moments viraux...',
    'up.stage6': 'Découpe des clips et sous-titres...',
    'up.stage.label': 'Étape {n} / {total}',

    // VideoClips
    'vc.back': 'Retour',
    'vc.source': '// Vidéo source',
    'vc.title.suffix': '',
    'vc.processed': 'traité en {t}s',
    'vc.min': 'min',
    'vc.stat.clips': 'Clips',
    'vc.stat.viral': 'Viral moyen',
    'vc.stat.hot': 'Hot picks',
    'vc.stat.time': 'Temps proc',
    'vc.list': 'Clips générés · classés par viralité',
    'vc.delete': 'Supprimer',
    'vc.delete.confirm': 'Supprimer cette vidéo et tous ses clips ?',
    'vc.deleted': 'Supprimé',
    'vc.notfound': 'Vidéo introuvable',
    'vc.loading': 'Chargement...',
    'vc.export': 'Exporter',
    'vc.export.started': 'Export HD lancé',
    'vc.share.toast': 'Connecte tes réseaux dans les paramètres',
    'vc.engage': 'Engage {n}',

    // Editor
    'ed.back': 'Retour aux clips',
    'ed.export': 'Exporter HD',
    'ed.export.toast': 'Export HD en file',
    'ed.tab.captions': 'Sous-titres',
    'ed.tab.crop': 'Recadrage',
    'ed.tab.music': 'Musique',
    'ed.tab.effects': 'Effets',
    'ed.caption.label': 'Sous-titre',
    'ed.subs.label': 'Sous-titres',
    'ed.subs.on.help': 'Affichés et incrustés sur l\'export.',
    'ed.subs.off.help': 'Aucun sous-titre — clip nu, prêt pour CapCut ou un autre éditeur.',
    'ed.color.label': 'Couleur d\'accent',
    'ed.zoom.label': 'Auto-zoom visages : {z}%',
    'ed.zoom.hint': 'Le recadrage intelligent garde les locuteurs au centre en 9:16.',
    'ed.music.selected': 'SÉLECTIONNÉ',
    'ed.emoji.added': 'Ajouté {e}',
    'ed.scores': 'Scores',
    'ed.score.viral': 'Viral',
    'ed.score.engage': 'Engage',
    'ed.score.retention': 'Rétention',
    'ed.notfound': 'Clip introuvable',

    // Admin
    'admin.tag': '// Admin',
    'admin.title': 'Contrôle plateforme',
    'admin.stat.users': 'Utilisateurs total',
    'admin.stat.videos': 'Vidéos',
    'admin.stat.clips': 'Clips',
    'admin.stat.pro': 'Utilisateurs Pro',
    'admin.recent': 'Utilisateurs récents',
    'admin.col.name': 'Nom',
    'admin.col.email': 'Email',
    'admin.col.plan': 'Plan',
    'admin.col.provider': 'Provider',
    'admin.col.joined': 'Inscrit',

    // common
    'common.loading': 'Chargement...',
    'common.notfound': 'Introuvable',
  },

  en: {
    'nav.home': 'Home',
    'nav.features': 'Features',
    'nav.pricing': 'Pricing',
    'nav.dashboard': 'Dashboard',
    'nav.upload': 'Upload',
    'nav.publishing': 'Publish',
    'nav.admin': 'Admin',
    'nav.login': 'Log in',
    'nav.signup': 'Get started',
    'nav.logout': 'Log out',

    'footer.tagline': 'Turn any long video into viral short clips. Detect the moments that matter, automatically.',
    'footer.product': 'Product',
    'footer.compare': 'Compare',
    'footer.support': 'Support',
    'footer.support.help': 'A question or an issue? Reach out.',
    'footer.copy': '© 2026 HighlightAI · Built for creators',

    'landing.badge': 'AI Highlight Engine · v2',
    'landing.title.line1': 'One long video.',
    'landing.title.line2': 'A dozen viral clips.',
    'landing.title.line3': 'Zero editing.',
    'landing.subtitle': 'Drop a podcast, stream, interview or any long-form recording. HighlightAI pinpoints the emotional peaks, the funny moments, and the viral hooks — then delivers ready-to-post TikToks, Shorts and Reels with dynamic captions.',
    'landing.cta.primary': 'Generate my first clips',
    'landing.cta.secondary': 'See pricing',
    'landing.social': 'Joined by 12,400+ creators · No credit card required',

    'landing.features.tag': '// What it does',
    'landing.features.title.line1': 'Smart enough to find',
    'landing.features.title.line2': 'the moments humans miss.',
    'landing.features.desc': 'Trained on millions of viral clips, our highlight engine analyzes audio energy, emotion peaks, audience reactions and pacing to extract the few moments worth posting.',
    'feature1.title': 'AI Detection',
    'feature1.desc': 'Funny moments, emotional peaks, energy spikes, action scenes & viral hooks detected automatically.',
    'feature2.title': 'Auto-clip 9:16 · 1:1 · 16:9',
    'feature2.desc': 'TikTok, Shorts, Reels and horizontal YouTube — all formats generated in one pass.',
    'feature3.title': 'TikTok-style captions',
    'feature3.desc': 'Animated subtitles, important keywords highlighted in color, perfectly synced with audio.',
    'feature4.title': 'Viral Score',
    'feature4.desc': 'Every clip gets an engagement, viral and retention estimate so you know which one to post first.',
    'feature5.title': 'Smart reframing',
    'feature5.desc': 'Auto zoom on faces, dynamic recadrage and emoji effects without manual editing.',
    'feature6.title': 'Multilingual',
    'feature6.desc': 'Whisper-powered transcription supporting 50+ languages with timestamp accuracy.',
    'feature7.title': 'URL import',
    'feature7.desc': 'Paste a YouTube, Twitch, Vimeo or Dailymotion link — AI downloads and clips automatically. No more manual downloads.',

    'landing.how.tag': '// Workflow',
    'landing.how.title.line1': 'Three steps.',
    'landing.how.title.line2': 'A wall of clips ready to post.',
    'step1.title': 'Drop your video',
    'step1.desc': 'Drag & drop MP4, MOV or AVI — up to 5GB. Or paste a stream link.',
    'step2.title': 'AI runs the show',
    'step2.desc': 'Whisper transcribes. GPT scores. Highlights are cut, captioned and ranked.',
    'step3.title': 'Post & go viral',
    'step3.desc': 'Download HD or share directly to TikTok, YouTube Shorts and Instagram Reels.',

    'landing.cta2.title.line1': 'Stop scrubbing your timeline.',
    'landing.cta2.title.line2': 'Let the AI hand you the gold.',
    'landing.cta2.desc': 'Free forever for the first 30 minutes of upload per month.',
    'landing.cta2.start': 'Start free',
    'landing.cta2.pricing': 'Pricing',

    'pricing.tag': '// Pricing',
    'pricing.title.line1': 'Start free.',
    'pricing.title.line2': 'Scale when you go viral.',
    'pricing.subtitle': 'No card required. Cancel any time.',
    'pricing.free.name': 'Free',
    'pricing.free.sub': 'Test the magic',
    'pricing.pro.name': 'Creator',
    'pricing.pro.sub': 'For ambitious creators',
    'pricing.studio.name': 'Studio',
    'pricing.studio.sub': 'Agencies & teams',
    'pricing.popular': 'Most popular',
    'pricing.founder': 'Founder pricing',
    'pricing.founder.sub': 'Locked in for early users',
    'pricing.reassurance': 'Current pricing is reserved for our first users and will increase after the official launch.',
    'pricing.month': '/ month',
    'pricing.start.free': 'Start free',
    'pricing.go': 'Go ',
    'pricing.custom': 'Need a custom plan for a media network or enterprise?',
    'pricing.contact': 'Contact us',
    'pf.minutes': '30 minutes upload / month',
    'pf.720p': 'Up to 720p export',
    'pf.captions1': 'Auto captions (1 language)',
    'pf.watermark': 'HighlightAI watermark',
    'pf.hd1080': 'HD export (1080p)',
    'pf.queue': 'Priority queue',
    'pf.unlimited': 'Unlimited uploads',
    'pf.hd1080.y': 'HD 1080p export',
    'pf.nowatermark': 'No watermark',
    'pf.urlimport': 'Direct URL import (YouTube, Twitch, Vimeo…)',
    'pf.multi': 'Multilingual captions (50+)',
    'pf.priority': 'Priority processing queue',
    'pf.direct': 'Direct posting TikTok / YT / IG',
    'pf.everything': 'Everything in Creator',
    'pf.4k': '4K export',
    'pf.team': 'Team workspace (5 seats)',
    'pf.brand': 'Custom brand kit',
    'pf.api': 'API access',
    'pf.support': 'Dedicated support',

    'auth.welcome': 'Welcome back',
    'auth.welcome.sub': 'Log in to keep generating viral clips.',
    'auth.create': 'Create your account',
    'auth.create.sub': '30 free minutes every month. No card required.',
    'auth.continue.google': 'Continue with Google',
    'auth.or': 'OR',
    'auth.name': 'Name',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.signin': 'Sign in',
    'auth.signing': 'Signing in...',
    'auth.creating': 'Creating...',
    'auth.signup': 'Create account',
    'auth.noaccount': 'No account?',
    'auth.signup.link': 'Sign up free',
    'auth.haveaccount': 'Already a member?',
    'auth.signin.link': 'Sign in',
    'auth.welcomed': 'Welcome back',
    'auth.invalid': 'Invalid credentials',
    'auth.created': "Account created — let's get you onboarded.",
    'auth.regfail': 'Registration failed',
    'auth.gfail': 'Google login failed',
    'auth.gconnect': 'Connecting to Google...',
    'auth.gsuccess': 'Signed in with Google',
    'auth.nosession': 'No session — redirecting...',
    'auth.failed': 'Failed. Redirecting to login...',

    'onb.step': 'Step',
    'onb.welcome.title': 'Welcome to HighlightAI',
    'onb.welcome.sub': "Let's set up your workspace in under a minute.",
    'onb.welcome.cta': 'Get started',
    'onb.type.title': 'What type of content do you mainly create?',
    'onb.type.sub': "We'll use this to personalise your future recommendations.",
    'onb.platforms.title': 'Where do you mainly publish?',
    'onb.platforms.sub': 'Select every platform that matters to you.',
    'onb.goal.title': 'What is your main goal?',
    'onb.goal.sub': "We'll soon tailor the AI Coach and insights to your goal.",
    'onb.cadence.title': 'How many videos do you publish each week?',
    'onb.cadence.sub': 'So we suggest content at the right cadence.',
    'onb.done.title': 'Your workspace is ready.',
    'onb.done.sub': "HighlightAI will progressively adapt to your answers.",
    'onb.title1': 'What do you create?',
    'onb.sub1': 'Helps us tune the highlight detection.',
    'onb.title2': 'Where will you post?',
    'onb.sub2': 'We optimise output formats accordingly.',
    'onb.title3': "You're all set.",
    'onb.sub3': 'Drop your first video and watch the magic.',
    'onb.podcast': 'Podcasts',
    'onb.gaming': 'Gaming',
    'onb.business': 'Business',
    'onb.finance': 'Finance',
    'onb.education': 'Education',
    'onb.fitness': 'Fitness',
    'onb.lifestyle': 'Lifestyle',
    'onb.interview': 'Interviews',
    'onb.vlog': 'Vlogs',
    'onb.sport': 'Sports',
    'onb.other': 'Other',
    'onb.goal.views': 'Get more views',
    'onb.goal.subs': 'Grow my audience',
    'onb.goal.clients': 'Find clients',
    'onb.goal.time': 'Save time',
    'onb.goal.brand': 'Build my brand',
    'onb.cadence.1-3': '1 – 3',
    'onb.cadence.4-7': '4 – 7',
    'onb.cadence.8-15': '8 – 15',
    'onb.cadence.15+': '15 or more',
    'onb.skip': 'Skip for now',
    'onb.back': 'Back',
    'onb.next': 'Continue',
    'onb.start': 'Open my workspace →',
    'onb.ready': 'Your highlight engine is tuned. Time to upload your first long video.',

    'dash.tag': '// Control Room',
    'dash.greeting': 'Hey {name}, ready for round two?',
    'dash.upload': 'New upload',
    'dash.stat.videos': 'Videos',
    'dash.stat.clips': 'Clips generated',
    'dash.stat.time': 'Processing time',
    'dash.stat.viral': 'Avg viral score',
    'dash.library': 'Your library',
    'dash.videos.count': '{n} videos',
    'dash.empty.title': 'Your library is empty',
    'dash.empty.desc': 'Upload your first long video and watch HighlightAI turn it into a wall of clips.',
    'dash.empty.cta': 'Upload first video',
    'dash.cats': 'Top categories',
    'dash.cats.empty': 'No data yet. Upload a video to populate this.',
    'dash.upgrade.title': 'Upgrade to Creator',
    'dash.upgrade.desc': 'Unlimited uploads, HD exports, no watermark.',
    'dash.upgrade.cta': 'See plans',
    'dash.ready': 'Ready',
    'dash.row.subtitle': '{type} · {n} clips · processed in {t}s',
    'dash.loading': 'Loading...',

    'up.tag': '// Ingest',
    'up.title': 'Drop your long video.',
    'up.subtitle': 'Up to 5GB · MP4 / MOV / AVI · podcasts, interviews, streams, gameplay, anything goes.',
    'up.drop.active': "Drop it like it's hot",
    'up.drop.idle': 'Drag & drop your video here',
    'up.drop.hint': 'or click to browse · MP4 / MOV / AVI · 5GB max',
    'up.label.title': 'Title',
    'up.label.title.ph': 'Episode 42 - The Future of AI',
    'up.label.type': 'Content type',
    'up.cta': 'Generate clips',
    'up.toobig': 'File too large (5GB max)',
    'up.rejected': 'File rejected',
    'up.first': 'Drop a video first',
    'up.proc.title': 'AI is doing its thing...',
    'up.proc.upload.title': 'Uploading...',
    'up.success': '{n} clips generated!',
    'up.fail': 'Upload failed',
    'up.stage1': 'Uploading video...',
    'up.stage2': 'Extracting audio...',
    'up.stage3': 'Transcribing with Whisper...',
    'up.stage4': 'Analyzing emotional peaks...',
    'up.stage5': 'Scoring viral moments...',
    'up.stage6': 'Cutting clips & captions...',
    'up.stage.label': 'Stage {n} / {total}',

    'vc.back': 'Back',
    'vc.source': '// Source video',
    'vc.processed': 'processed in {t}s',
    'vc.min': 'min',
    'vc.stat.clips': 'Clips',
    'vc.stat.viral': 'Avg viral',
    'vc.stat.hot': 'Hot picks',
    'vc.stat.time': 'Proc time',
    'vc.list': 'Generated clips · ranked by virality',
    'vc.delete': 'Delete',
    'vc.delete.confirm': 'Delete this video and all its clips?',
    'vc.deleted': 'Deleted',
    'vc.notfound': 'Video not found',
    'vc.loading': 'Loading...',
    'vc.export': 'Export',
    'vc.export.started': 'HD export started',
    'vc.share.toast': 'Connect your socials in settings',
    'vc.engage': 'Engage {n}',

    'ed.back': 'Back to clips',
    'ed.export': 'Export HD',
    'ed.export.toast': 'HD export queued',
    'ed.tab.captions': 'Captions',
    'ed.tab.crop': 'Crop',
    'ed.tab.music': 'Music',
    'ed.tab.effects': 'Effects',
    'ed.caption.label': 'Caption',
    'ed.subs.label': 'Subtitles',
    'ed.subs.on.help': 'Shown in the preview and burned into the export.',
    'ed.subs.off.help': 'No subtitles — bare clip, ready for CapCut or another editor.',
    'ed.color.label': 'Highlight color',
    'ed.zoom.label': 'Auto zoom on faces: {z}%',
    'ed.zoom.hint': 'Smart reframing keeps speakers centered in 9:16.',
    'ed.music.selected': 'SELECTED',
    'ed.emoji.added': 'Added {e}',
    'ed.scores': 'Scores',
    'ed.score.viral': 'Viral',
    'ed.score.engage': 'Engage',
    'ed.score.retention': 'Retention',
    'ed.notfound': 'Clip not found',

    'admin.tag': '// Admin',
    'admin.title': 'Platform control',
    'admin.stat.users': 'Total users',
    'admin.stat.videos': 'Videos',
    'admin.stat.clips': 'Clips',
    'admin.stat.pro': 'Pro users',
    'admin.recent': 'Recent users',
    'admin.col.name': 'Name',
    'admin.col.email': 'Email',
    'admin.col.plan': 'Plan',
    'admin.col.provider': 'Provider',
    'admin.col.joined': 'Joined',

    'common.loading': 'Loading...',
    'common.notfound': 'Not found',
  },
};

const LangCtx = createContext({ lang: 'fr', t: (k) => k, setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem('highlightai_lang') || 'fr');

  useEffect(() => { localStorage.setItem('highlightai_lang', lang); }, [lang]);

  const setLang = (l) => setLangState(l);

  const t = (key, vars = {}) => {
    const dict = STRINGS[lang] || STRINGS.fr;
    let str = dict[key] ?? STRINGS.en[key] ?? key;
    Object.entries(vars).forEach(([k, v]) => { str = str.replace(`{${k}}`, v); });
    return str;
  };

  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
};

export const useT = () => useContext(LangCtx);
